import { render } from "./CheckUpFaq_Check.vue?vue&type=template&id=07832126"
import script from "./CheckUpFaq_Check.vue?vue&type=script&lang=js"
export * from "./CheckUpFaq_Check.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__